import { Button } from '@/components/ui/button'
import { RohsDeclarationReadinessProgress } from '@/v2/components/rohs/RohsDeclarationReadinessProgress'
import type { RohsProductComplianceFileDeclarationOfConformityRequirement } from '@/v2/lib/rohsProductComplianceFileDeclarationOfConformityRequirements'
import type { RohsBriefingStep } from '../../utils/rohsLegislationBriefing'
import { V2RohsLegislationBriefingStepShell } from './V2RohsLegislationBriefingStepShell'

export function V2RohsEuDeclarationStep({
  step,
  index,
  declarationLabel,
  declarationEvaluation,
  onOpenDeclarationDialog,
}: {
  step: RohsBriefingStep
  index: number
  declarationLabel: string
  declarationEvaluation: {
    requirements: RohsProductComplianceFileDeclarationOfConformityRequirement[]
    generateReady: boolean
  } | null
  onOpenDeclarationDialog: () => void
}) {
  const showReadiness =
    step.status !== 'done' && declarationEvaluation != null
  const showGenerateAction = declarationEvaluation != null

  return (
    <V2RohsLegislationBriefingStepShell
      step={step}
      index={index}
      actions={
        showGenerateAction ? (
          <Button
            type='button'
            size='sm'
            variant='outline'
            onClick={onOpenDeclarationDialog}
          >
            {declarationLabel}
          </Button>
        ) : undefined
      }
    >
      {showReadiness ? (
        <RohsDeclarationReadinessProgress
          requirements={declarationEvaluation.requirements}
          generateReady={declarationEvaluation.generateReady}
        />
      ) : null}
    </V2RohsLegislationBriefingStepShell>
  )
}
